import React from "react"
import { Link } from "gatsby"
import { ParallaxBanner } from "react-scroll-parallax"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Wrapper from "../components/wrapper"
import GridItem from "../components/griditem"
import GameItem from "../components/gameitem"

const SecondPage = () => (
  <Layout>
    <SEO title="Hilfe und Kontakt" />
    <ParallaxBanner
      className="your-class"
      layers={[
        {
          image:
            "https://images.unsplash.com/photo-1564049489314-60d154ff107d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2561&q=80",
          amount: 0.2,
        },
      ]}
      style={{
        height: "200px",
      }}
    ></ParallaxBanner>
    <Wrapper padding>
      <h2 style={{ textAlign: "center", fontWeight: 500, width: "100%" }}>
        Hilfe und Kontakt
      </h2>
      <ul class="portfolioPrev">
        Haben Sie Fragen?
        <br />
        <br />
        Kontaktieren Sie uns unter der telefonischen Hotline: 08005895405 oder
        beim E-Mail-Support:{" "}
        <a
          href="mailto:info@care-tech.info
"
        >
          info@care-tech.info
        </a>
        .<br />
        <br />
        <br />
        Brain Offices GmbH <br />
        Mühlenstr. 8 a <br />
        D-14167 Berlin
      </ul>
    </Wrapper>
  </Layout>
)

export default SecondPage
